<template>
  <ul>
    <template v-for="(item, key) in btns">
      <li v-if="item.value" @click="footerClick(item)" :key="key">
        {{ item.text || btnText[item.value] }}
      </li>
    </template>
  </ul>
</template>

<script>
export default {
  props: {
    btns: {
      type: Array,
      default() {
        return []
      }
    },
    page: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      btnText: ['', '返回', '再次验证', '举报', '公众号']
    }
  },
  methods: {
    footerClick(item) {
      console.log(item)
      if (item.value == 1) {
        this.$router.go(-1)
      } else if (item.value == 2) {
        // this.$router.push('/' + this.page.applet.code + '/0')
        this.$store.commit('SET_JudgeResult', 'xxxx')
        setTimeout(() => {
          this.$router.push({ path: '/identify', query: { model: 2, appletId: this.page.applet.appletId, url: this.$route.query.url } })
        }, 200);
        // ?model=2&appletId=299&url=https%3A%2F%2Fy3wm.cn%2Fty6%2F0
      } else if (item.value == 3) {
        this.$router.push({ path: '/tip', query: { appletId: this.page.applet.appletId } })

      } else if (item.value == 4) {
        window.open(item.url)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
ul {
  display: flex;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 48px;
  line-height: 48px;
  font-size: 0.4rem;
  z-index: 3000;
  color: #409eff;
  padding: 0;

  li {
    margin: 0;
    padding: 0;
    flex: 1;
    text-align: center;
    background: #fff;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/main/components/footerBtn.vue